<!-- MENU -->
<nav class="navbar navbar-expand-lg nav-Color" (click)="hiddeToggleChat()">
    <div class="container-fluid menu-header" [class.menu-header--quick]="showQuickLanguageSwitch">
        <a #languageReturnFocus class="navbar-brand" href="#">
            <img class="logo" src="./assets/img/lengua.png" alt="Bravum">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown" aria-expanded="false" [attr.aria-label]="'navigation.toggle' | t">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" (click)="openModal(modalRestaurant, true)" style="cursor: pointer;">{{ 'navigation.restaurantInfo' | t }}</a>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        {{ 'navigation.sections' | t }}
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <li *ngFor="let icon of icons; trackBy: trackByIcon">
                            <a data-toggle="collapse" data-target=".navbar-collapse" class="dropdown-item"
                                data-bs-toggle="collapse" (click)="goSection(icon.id, 1)" class="dropdown-item">
                                {{icon.name }}
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item dropdown filter-dropdown">
                    <button class="nav-link dropdown-toggle filter-trigger" id="navbarDropdownMenuFiltros" type="button"
                        [attr.aria-expanded]="showDropdownMenu" (click)="toggleFilters($event)"
                        aria-controls="menuFiltersPanel">
                        {{ 'filters.title' | t }}
                    </button>
                    <div *ngIf="showDropdownMenu" class="filter-backdrop" aria-hidden="true"
                        (click)="closeFilters()"></div>
                    <ul id="menuFiltersPanel" class="dropdown-menu filter-menu" aria-labelledby="navbarDropdownMenuFiltros"
                        [ngClass]="{'show': showDropdownMenu}">
                        <li class="filter-panel" (click)="$event.stopPropagation()">
                            <div class="filter-panel__header">
                                <div>
                                    <strong>{{ 'filters.filterProducts' | t }}</strong>
                                    <span *ngIf="hasActiveFilters" aria-live="polite">{{ 'filters.results' | t:{ count: visibleResultCount } }}</span>
                                </div>
                                <button type="button" class="filter-panel__close" [attr.aria-label]="'filters.close' | t"
                                    (click)="closeFilters()">&times;</button>
                            </div>

                            <div class="filter-toggle-group" [attr.aria-label]="'filters.personal' | t">
                                <button type="button" class="filter-toggle" [class.filter-toggle--active]="isFilterLike"
                                    [attr.aria-pressed]="isFilterLike" (click)="saveFilters(1,1)">
                                    {{ 'filters.favorites' | t }}
                                </button>
                                <button type="button" class="filter-toggle" [class.filter-toggle--active]="isFilterQualities"
                                    [attr.aria-pressed]="isFilterQualities" (click)="saveFilters(1,2)">
                                    {{ 'filters.qualities' | t }}
                                </button>
                            </div>

                            <div class="filter-field">
                                <label for="product-name-filter">{{ 'filters.searchByName' | t }}</label>
                                <input id="product-name-filter" type="search" class="form-control"
                                    autocomplete="off" [placeholder]="'filters.searchExample' | t"
                                    [(ngModel)]="searchName" (input)="onInputChange($event)">
                            </div>

                            <fieldset class="filter-field filter-price">
                                <legend>{{ 'filters.price' | t }}</legend>
                                <div class="filter-price__inputs">
                                    <label>
                                        <span class="visually-hidden">{{ 'filters.minPrice' | t }}</span>
                                        <input type="number" inputmode="decimal" class="form-control"
                                            [attr.aria-label]="'filters.minPrice' | t" [placeholder]="'filters.minimum' | t" min="0" step="any"
                                            [ngModel]="priceFilterValue(1)"
                                            (ngModelChange)="setPriceFilter($event, 1)"
                                            [disabled]="currencyState.loading">
                                    </label>
                                    <span aria-hidden="true">—</span>
                                    <label>
                                        <span class="visually-hidden">{{ 'filters.maxPrice' | t }}</span>
                                        <input type="number" inputmode="decimal" class="form-control"
                                            [attr.aria-label]="'filters.maxPrice' | t" [placeholder]="'filters.maximum' | t" min="0" step="any"
                                            [ngModel]="priceFilterValue(2)"
                                            (ngModelChange)="setPriceFilter($event, 2)"
                                            [disabled]="currencyState.loading">
                                    </label>
                                </div>
                                <small>{{ 'filters.currentCurrency' | t:{ currency: currentFilterCurrency || ('common.notAvailable' | t) } }}</small>
                                <p *ngIf="priceFilterError" class="filter-error" role="alert">{{ priceFilterError | t }}</p>
                            </fieldset>

                            <button type="button" class="filter-more" [disabled]="otherFilter.length === 0"
                                [attr.aria-disabled]="otherFilter.length === 0"
                                (click)="openModalMoreFilter(modalMasFiltros, $event)">
                                {{ 'filters.more' | t }}<span *ngIf="moreFilter.length"> ({{ moreFilter.length }})</span>
                            </button>
                            <small *ngIf="otherFilter.length === 0" class="filter-help">
                                {{ 'filters.noQualities' | t }}
                            </small>

                            <div class="filter-panel__actions">
                                <button type="button" class="btn btn-outline-secondary" (click)="cleanFilter()"
                                    [disabled]="!hasActiveFilters && !searchName && minPriceDish === null && maxPriceDish === null">
                                    {{ 'filters.clear' | t }}
                                </button>
                                <button type="button" class="btn btn-primary" (click)="appyFilters()"
                                    [disabled]="!!priceFilterError || currencyState.loading">
                                    {{ 'filters.apply' | t }}
                                </button>
                            </div>
                        </li>
                    </ul>
                </li>

                <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                    <a class="nav-link" (click)="openModal(modalProfile)" style="cursor: pointer;">{{ 'navigation.myProfile' | t }}</a>
                </li>

                <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                    <a class="nav-link" (click)="openModal(modalProfile, true)" style="cursor: pointer;">{{ 'navigation.guestProfile' | t }}</a>
                </li>




            </ul>
        </div>
        <section *ngIf="showQuickLanguageSwitch" class="quick-language" aria-label="Idioma / Language"
            [attr.aria-busy]="quickLanguageChecking || quickLanguageChanging">
            <div class="quick-language__buttons">
                <button type="button" class="quick-language__button" lang="es" dir="ltr"
                    aria-label="Cambiar a Español" aria-describedby="quick-language-status"
                    [disabled]="quickLanguageChecking || quickLanguageChanging || !quickLanguageAvailability.es"
                    (click)="switchQuickLanguage('es')">
                    <span aria-hidden="true">🇪🇸</span> Español
                </button>
                <button type="button" class="quick-language__button" lang="en" dir="ltr"
                    aria-label="Switch to English" aria-describedby="quick-language-status"
                    [disabled]="quickLanguageChecking || quickLanguageChanging || !quickLanguageAvailability.en"
                    (click)="switchQuickLanguage('en')">
                    <span aria-hidden="true">🇬🇧</span> English
                </button>
            </div>
            <p id="quick-language-status" class="quick-language__status" role="status" dir="ltr">
                <span *ngIf="quickLanguageChecking">Comprobando idiomas… / Checking languages…</span>
                <span *ngIf="quickLanguageChanging">Cambiando idioma… / Switching language…</span>
                {{ quickLanguageMessage }}
            </p>
        </section>
    </div>
</nav>
<!-- MENU -->

<div class="container-fluid" (click)="hiddeToggleChat()">
    <div class="row justify-content-center">
        <div class="col-8 restaurant">
            <img src="{{ restaurant.Logo }}" (click)="openModal(modalRestaurant)">
            <p class="mainTitle">{{ restaurant.NombreComercio }}</p>
        </div>
        <div class="col-12">
            <div class="alert alert-secondary" role="alert">
                <nav [attr.aria-label]="'common.home' | t">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item" [routerLink]="['/']">{{ 'common.home' | t }}</li>
                        <li class="breadcrumb-item" aria-current="page">{{ restaurant.NombreComercio }}</li>
                        <li class="breadcrumb-item active" aria-current="page">{{ sucursalName }}</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <section class="currency-toolbar" [attr.aria-label]="'currency.selector' | t">
        <div class="currency-control">
            <label for="currency-selector">{{ 'currency.label' | t }}</label>
            <select id="currency-selector" class="form-select form-select-sm"
                [ngModel]="currencyState.requestedCurrency || currencyState.baseCurrency"
                (ngModelChange)="onCurrencyChange($event)"
                [disabled]="!currencyState.baseCurrency">
                <option *ngFor="let option of currencyOptions" [ngValue]="option.code">
                    {{ ('currencies.' + option.code) | t }}
                </option>
            </select>
        </div>
        <div class="currency-status" aria-live="polite">
            <span *ngIf="currencyState.baseCurrency">{{ 'currency.base' | t:{ currency: currencyState.baseCurrency } }}</span>
            <span *ngIf="currencyState.loading">{{ 'currency.loading' | t:{ currency: currencyState.requestedCurrency } }}</span>
            <span class="currency-error" *ngIf="currencyState.error">{{ 'currency.unavailable' | t }}</span>
            <span *ngIf="currencyState.updatedAtUtc">
                {{ (currencyState.isStale ? 'currency.ratePrevious' : 'currency.ratePublished') | t:{ date: formatRateTimestamp(currencyState.updatedAtUtc) } }}
            </span>
            <span *ngIf="currencyState.baseCurrency && currencyState.selectedCurrency !== currencyState.baseCurrency">
                {{ 'currency.approximate' | t:{ currency: currencyState.baseCurrency } }}
            </span>
            <a *ngIf="currencyState.attributionUrl" [href]="currencyState.attributionUrl"
                target="_blank" rel="noopener noreferrer">{{ 'currency.attribution' | t }}</a>
        </div>
    </section>
    <!-- CHANGE MENU -->
    <div class="row" style="padding: 0 10px; margin-bottom: 10px;" *ngIf="menu.length > 1">
        <button type="button" class="btn btn-primary" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed"
            aria-controls="collapseExample">
            {{ 'menu.available' | t }}
        </button>

        <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" style="background: white;">
            <ul>
                <li *ngFor="let item of menu; let menuIndex = index">
                    <input [id]="'available-menu-' + menuIndex" type="checkbox"
                        (change)="setMenu(item.idCarta,1)" [checked]="item.check">
                    <label [for]="'available-menu-' + menuIndex">{{ item.nombre }}</label>
                </li>
            </ul>
        </div>
    </div>
    <!-- END CHANGE MENU -->
    <div class="row" id="menu">
        <div class="col-12 menuTitle">
            <h5>{{ itemMenu.nombre }}</h5>
        </div>
        <div class="col-12 dIcons" id="iconContainer" [class.fixedIcons]="isfixed"
            style="border-bottom:1px solid #000;border-top:1px solid #000;background:#fff;height:70px;z-index:100;">
            <drag-scroll #scroller id="main" style="scroll-behavior:smooth;">
                <div drag-scroll-item #iconItem *ngFor="let icon of icons; let i = index; trackBy: trackByIcon"
                    style="text-align:center; padding:10px; margin-right:15px;" (click)="goSection(icon.id, 2)">
                    <img id="{{icon.id}}" [src]="icon.activated ? './assets/img/Iconos/Activados/' + icon.icon + '.png'
                                  : './assets/img/Iconos/' + icon.icon + '.png'" />
                    <p>{{icon.name}}</p>
                </div>
            </drag-scroll>
        </div>

    </div>

    <div class="row">
        <div class="alert alert-info" role="alert" *ngIf="translationUnavailable">
            {{ 'menu.translationUnavailable' | t }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="sections.length == 0">
            {{ 'menu.none' | t }}
        </div>
        <div *ngIf="hasActiveFilters" class="filter-results-summary" aria-live="polite">
            <span>{{ 'filters.results' | t:{ count: visibleResultCount } }}</span>
            <button class="btnClean btn btn-outline-secondary" type="button" (click)="cleanFilter()">{{ 'filters.clear' | t }}</button>
        </div>
        <div *ngIf="hasActiveFilters && visibleResultCount === 0" class="alert alert-info filter-empty" role="status">
            {{ 'filters.empty' | t }}
        </div>
        <main *ngFor="let item of sections; let indexSection = index;">
            <div class="section-anchor-spacer"></div>

            <div *ngFor="let section of item.Secciones; let indexSections = index;" id="sec-{{section.Pos}}">
                <div class="col-12 section"
                    [ngStyle]="{'background-color': section.TipoSeccion == 1 ? '#c51c23': '#831217' }">
                    <h5>{{section.NombreSeccion}}</h5>
                </div>

                <div class="col-12 dishes">

                    <!-- 🔄 Spinner mientras se cargan los platos -->
                    <div *ngIf="section.loading" class="text-center py-3">
                        <div class="spinner-border text-danger" role="status">
                            <span class="visually-hidden">{{ 'accessibility.loading' | t }}</span>
                        </div>
                    </div>

                    <!-- 🟢 Mostrar platos una vez que cargó -->
                    <ng-container *ngIf="!section.loading">
                        <!-- Ícono superior si es tipo 3 -->
                        <div *ngIf="section.TipoItem === 3">
                            <img [src]="section.IconOn" alt="">
                        </div>

                        <ng-container *ngFor="let dish of section.Platos; let indexPlato = index; trackBy: trackByDish">
                            <!-- Evita mostrar si Estado = 1 -->
                            <div *ngIf="dish.Estado !== 1" class="product"
                                [ngClass]="{ 'boxMessage': dish.ControlaInventario === 3 }"
                                [id]="'dish-' + dish.IdPlato">

                                <!-- Si NO es mensaje -->
                                <div class="dishDetail" *ngIf="dish.ControlaInventario !== 3">
                                    <div class="container-img" *ngIf="dish.Foto?.trim()"
                                        (click)="dish.Estado !== 2 && detailDish(dish.IdPlato)">
                                        <div class="img">
                                            <img [src]="getUrlImage(dish.Foto)" [alt]="dish.Nombre ? ('menu.dishPhoto' | t:{ name: dish.Nombre }) : ('accessibility.dishImage' | t)"
                                                loading="lazy" (error)="noFood(indexSection, indexSections, indexPlato)">
                                            <div *ngIf="dish.Estado === 2" class="overlay">{{ 'menu.outOfStock' | t }}</div>
                                        </div>
                                    </div>

                                    <div class="product-detail" [class.product-detail--full]="!dish.Foto?.trim()">
                                        <div class="details" (click)="dish.Estado !== 2 && detailDish(dish.IdPlato)">
                                            <p class="product-title" [ngClass]="{ 'notAvailable': dish.Estado === 2 }">
                                                {{ dish.Nombre }}
                                            </p>
                                            <p class="product-desc" [ngClass]="{ 'notAvailable': dish.Estado === 2 }">
                                                {{ dish.Descripcion }}
                                            </p>
                                            <p class="product-price" [ngClass]="{ 'notAvailable': dish.Estado === 2 }">
                                                {{ dish.Precio | bravumCurrency:currencyState:currencyLocale }}
                                            </p>
                                        </div>

                                        <div class="actions">
                                            <img *ngIf="!dish.Liked" src="./assets/img/heart.png" loading="lazy"
                                                (click)="dish.Estado !== 2 && setLike(indexSection, indexSections, indexPlato)">
                                            <img *ngIf="dish.Liked" src="./assets/img/heartLiked.png" loading="lazy"
                                                (click)="dish.Estado !== 2 && setLike(indexSection, indexSections, indexPlato)">
                                        </div>
                                    </div>
                                </div>

                                <!-- Si es mensaje -->
                                <div class="dishMessageDetail" *ngIf="dish.ControlaInventario === 3">
                                    <div class="container-img">
                                        <div class="img" [ngStyle]="{
                      'background': 'url(' + getUrlImage(dish.Foto) + ') 43% 26% / 164px 149px no-repeat'
                    }">
                                        </div>
                                    </div>
                                    <div class="product-detailMessage">
                                        <div class="details">
                                            <p class="product-title">{{ dish.Nombre }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </main>

    </div>


</div>

<!-- scroll-to-top.component.html -->
<!-- scroll-to-top.component.html -->
<button *ngIf="isShowTop" class="btn btn-primary scroll-to-top-btn-menu" (click)="scrollToTop()" type="button"
    data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
    aria-expanded="false" [attr.aria-label]="'accessibility.menu' | t">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-menu-down"
        viewBox="0 0 16 16">
        <path
            d="M7.646.146a.5.5 0 0 1 .708 0L10.207 2H14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3.793zM1 7v3h14V7zm14-1V4a1 1 0 0 0-1-1h-3.793a1 1 0 0 1-.707-.293L8 1.207l-1.5 1.5A1 1 0 0 1 5.793 3H2a1 1 0 0 0-1 1v2zm0 5H1v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM2 4.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5" />
    </svg>
</button>
<button *ngIf="isShowTop" class="btn btn-primary scroll-to-top-btn" (click)="scrollToTop()" [attr.aria-label]="'accessibility.scrollTop' | t">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-circle"
        viewBox="0 0 16 16">
        <path fill-rule="evenodd"
            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z" />
    </svg>
</button>

<button class="btn btn-primary scroll-to-top-btn-chat" (click)="toggleChat()"
    [attr.aria-label]="(isOpenChat ? 'chat.close' : 'chat.open') | t">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-square-dots"
        viewBox="0 0 16 16">
        <path
            d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
        <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </svg>
</button>


<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>

<!-- MODAL RESTAURANTE -->
<ng-template #modalRestaurant let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{restaurant.NombreComercio}}</h5>
    </div>
    <div class="modal-body" style="text-align: center;">
        <img src="{{restaurant.Logo}}" [alt]="restaurant.NombreComercio" style="width: 300px;max-width: 300px;">
        <p><span style="font-weight: bold;">{{ 'restaurant.tradeName' | t }}</span>: {{restaurant.MarcaComercial}}</p>
        <p><span style="font-weight: bold;">{{ 'restaurant.address' | t }}</span>: {{restaurant.Direcion}}</p>
        <p><span style="font-weight: bold;">{{ 'restaurant.email' | t }}</span>: {{restaurant.Correo}}</p>
        <p><span style="font-weight: bold;">{{ 'restaurant.vat' | t }}</span>: {{restaurant.NumeroVAT}}</p>
        <div class="row">
            <p><span style="font-weight: bold;">{{ 'restaurant.offering' | t }}</span></p>
            <div class="col-md-12">


                <span *ngFor="let item of restaurant.Oferta" class="badge badge-info"
                    style="margin: 3px;">{{item.elementName}}</span>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="modal.close('')">{{ 'common.ok' | t }}</button>
    </div>
</ng-template>

<!-- MODAL PERFIL -->
<ng-template #modalProfile let-modal>
    <div class="modal-header">
        <h5 *ngIf="!isInvitatedUser" class="modal-title" id="exampleModalLongTitle">{{ 'profile.hello' | t:{ name: userInformation.name } }}</h5>
        <h5 *ngIf="isInvitatedUser" class="modal-title" id="exampleModalLongTitle">{{ 'profile.guestHello' | t }}</h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <select name="" id="" class="form-control" blur="true" style="display: none;">
            </select>
            <div class="form-group">
                <label for="exampleInputEmail1">{{ 'profile.language' | t }}</label>
                <select name="" id="" class="form-control" [(ngModel)]="idiomaUser">
                    <option *ngFor="let item of idiomas" value="{{item.value}}">
                        {{ ('languages.' + item.code) | t }}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="exampleInputEmail1">{{ 'profile.currency' | t }}</label>
                <select name="" id="" class="form-control" [(ngModel)]="monedaUser">
                    <option *ngFor="let item of moneda" value="{{item.value}}">
                        {{ ('currencies.' + item.code) | t }}</option>
                </select>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="btn-group" role="group" [attr.aria-label]="'navigation.myProfile' | t">
                <button type="button" class="btn btn-primary" (click)="saveGeneralConfiguration()"
                    style="font-size: 12px;">{{ 'common.saveChanges' | t }}</button>
                <button class="btn btn-success" (click)="openBackDropCustomClass(modalMyQuality)"
                    style="font-size: 12px;">{{ 'profile.myQualities' | t }}</button>
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.close('')">{{ 'common.close' | t }}</button>
        <button *ngIf="!isInvitatedUser" class="btn btn-danger" (click)="deleteProfile()">{{ 'profile.signOut' | t }}</button>
    </div>
</ng-template>


<!-- MODAL MIS CUALIDADES  -->
<ng-template #modalMyQuality let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'filters.qualities' | t }}</h5>
        <button type="button btn-danger" data-dismiss="modal" [attr.aria-label]="'common.close' | t" (click)="dismissModal(modalMyQuality)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="text-align: center;">
        <div class="form-group">
            <label for="exampleInputEmail1">{{ 'qualities.functional' | t }}</label>
            <select name="" id="" class="form-control" (change)="changeCualidad($event.target)">
                <option *ngFor="let item of cualidades" value="{{item.IdTipoUnidadMedida}}-{{item.Nombre}}-{{item.Id}}">
                    {{ item.Nombre }}
                </option>
            </select>
        </div>
        <div class="form-group">
            <label for="exampleInputEmail1">{{ 'qualities.selectUnit' | t }}</label>
            <select name="" id="" class="form-control" (change)="changeUnidad($event.target)">
                <option *ngFor="let item of filterUnidades; let index = index"
                    value="{{item.UnidadDeMedida}}*{{item.Id}}*{{item.Maximo}}*{{item.Minimo}}" [selected]="index == 0">
                    {{ item.UnidadDeMedida }}
                </option>
            </select>
        </div>
        <div class="form-group" *ngIf="showTextValue">
            <label for="exampleInputEmail1">{{ 'qualities.unitValue' | t }}</label>
            <input type="text" class="form-control" [placeholder]="'qualities.unitValue' | t">
        </div>


        <div class="form-group" *ngIf="showRangeValue">


            <label for="exampleInputEmail1">{{ 'qualities.range' | t }}</label>
            <div class="input-group">
                <span class="input-group-text">{{ 'qualities.between' | t }}</span>
                <input type="text" class="form-control" (change)="setValueRange($event.target, 1)" value="{{minValue}}"
                    readonly disabled />
                <span class="input-group-text">{{ 'qualities.and' | t }}</span>
                <input type="text" class="form-control" (change)="setValueRange($event.target, 2)" value="{{maxValue}}"
                    readonly disabled />
            </div>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">

                <input value="{{minValue}}" style="width: 30%;" class="form-control"
                    (change)="setValueCua($event.target, 1)">
                <input value="{{maxValue}}" style="width: 30%;" class="form-control"
                    (change)="setValueCua($event.target, 2)">
            </div>

        </div>

        <button type="button" class="btn btn-primary" (click)="setPersonalQualitys()">{{ 'qualities.add' | t }}</button>
        <div>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">{{ 'qualities.unitType' | t }}</th>
                        <th scope="col">{{ 'menu.unit' | t }}</th>
                        <th scope="col">{{ 'menu.value' | t }}</th>
                        <th scope="col">{{ 'common.action' | t }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of listLikedQualities">
                        <th scope="row">{{item.TipoUnidad}}</th>
                        <td>{{item.Unidad | replaceNo}}</td>
                        <td *ngIf="item.logic">{{item.Unidad}}</td>
                        <td *ngIf="!item.logic">{{item.min}}-{{item.max}}</td>
                        <td><button class="btn btn-danger" (click)="deleteMyQuality(item)"><i
                                    class="fa fa-trash"></i></button></td>
                    </tr>
                </tbody>
            </table>
        </div>


    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" data-dismiss="modal" [attr.aria-label]="'common.close' | t" (click)="dismissModal(modalMyQuality)">
            <span>{{ 'common.saveChanges' | t }}</span>
        </button>
    </div>
</ng-template>


<!-- MODAL CARTAS -->
<ng-template #modalCartas let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'menu.selectMenus' | t }}</h5>
    </div>
    <div class="modal-body">
        <ul>
            <li *ngFor="let item of menu; let menuIndex = index">
                <input [id]="'initial-menu-' + menuIndex" type="checkbox"
                    (change)="setMenu(item.idCarta)" [checked]="item.check">
                <label [for]="'initial-menu-' + menuIndex">{{ item.nombre }}</label>
            </li>
        </ul>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="checkedMenus($event)">{{ 'common.ok' | t }}</button>
    </div>
</ng-template>

<!-- MODAL MAS FILTROS -->
<ng-template #modalMasFiltros let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'filters.more' | t }}</h5>
    </div>
    <div class="modal-body">
        <div>
            <label for="nombre-select">{{ 'qualities.functional' | t }}:</label>
            <select id="nombre-select" [(ngModel)]="selectedNombre"
                (change)="onNombreChange(); $event.stopPropagation()" class="form-control">
                <option *ngFor="let group of otherFilter" [value]="group.Nombre">{{ group.Nombre }}</option>
            </select>
        </div>

        <div *ngIf="descs.length > 0 && showSelectedDesc">
            <label for="quality-unit-select">{{ 'menu.unit' | t }}:</label>
            <select id="quality-unit-select" [(ngModel)]="selectedDesc" (change)="onDescChange()" class="form-control">
                <option *ngFor="let desc of descs" [value]="desc.Desc">{{ desc.Desc }}</option>
            </select>
        </div>

        <div>
            <label for="quality-value-select">{{ 'menu.value' | t }}:</label>
            <select id="quality-value-select" [(ngModel)]="selectedValue" class="form-control">
                <option *ngFor="let valor of valores">{{ valor }}</option>
            </select>
        </div>
        <br>
        <button class="btn btn-primary" [disabled]="!selectedNombre || selectedValue === ''"
            (click)="addMoreFilter(); $event.stopPropagation()">{{ 'qualities.addFilter' | t }}</button>

        <div class="row">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">{{ 'menu.quality' | t }}</th>
                        <th scope="col">{{ 'menu.unit' | t }}</th>
                        <th scope="col">{{ 'menu.value' | t }}</th>
                        <th scope="col">{{ 'common.action' | t }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of moreFilter; let index = index">
                        <td>{{ item.cualidad }}</td>
                        <td>{{ item.unidad }}</td>
                        <td>{{ item.valor }}</td>
                        <td><button class="btn btn-danger"
                                (click)="deleteMoreFilter(index); $event.stopPropagation()"><i
                                    class="fa fa-trash"></i></button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="toggleDropdownMenu()">{{ 'common.ok' | t }}</button>
    </div>
</ng-template>


<app-login-register></app-login-register>

<!-- CHAT -->
<div class="chat-container" [class.open]="isOpenChat" (click)="onOverlayClick($event)">
    <div class="chat-header" (click)="toggleChat()">
        <button class="toggle-button" [attr.aria-label]="(isOpenChat ? 'chat.close' : 'chat.open') | t">
            {{ 'chat.title' | t }}
        </button>
    </div>
    <div class="chat-messages" #chatContainer>
        <div class="message" *ngFor="let msg of conversation; let i = index"
            [ngClass]="{ 'server': msg.sender === 'server', 'user': msg.sender === 'user', 'has-products': msg.products?.length, 'is-loading': msg.loading }">
            <span class="content">{{ msg.translationKey ? (msg.translationKey | t) : msg.message }}</span>
            <span *ngIf="msg.loading" class="chat-loading-dots" aria-hidden="true"><i></i><i></i><i></i></span>
            <div class="chat-product-list" *ngIf="msg.products?.length">
                <article class="chat-product-card" *ngFor="let product of msg.products">
                    <img *ngIf="product.imagen" class="chat-product-image" [src]="getUrlImage(product.imagen)"
                        [alt]="product.nombre" loading="lazy">
                    <div class="chat-product-body">
                        <strong class="chat-product-name">{{ product.nombre }}</strong>
                        <span class="chat-product-price">{{ product.precio | bravumCurrency:currencyState:currencyLocale }}</span>
                        <p class="chat-product-description" *ngIf="product.descripcion">{{ product.descripcion }}</p>
                        <button type="button" class="chat-product-action" (click)="openChatProduct(product)">
                            {{ 'menu.viewDish' | t }}
                        </button>
                    </div>
                </article>
                <p class="chat-currency-note"
                    *ngIf="currencyState.baseCurrency && currencyState.selectedCurrency !== currencyState.baseCurrency">
                    {{ 'currency.approximate' | t:{ currency: currencyState.baseCurrency } }}
                </p>
            </div>
        </div>
    </div>
    <div class="chat-input">
        <input type="text" [(ngModel)]="messagechat" [placeholder]="'chat.placeholder' | t" [attr.aria-label]="'chat.placeholder' | t"
            (keydown.enter)="sendMessage()">
        <button (click)="sendMessage()" [attr.aria-label]="'chat.send' | t">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send-fill"
                viewBox="0 0 16 16">
                <path
                    d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
            </svg>
        </button>

        <input type="file" id="fileInput" (change)="onFileSelected($event)" hidden />
        <button (click)="onFileInputClick()" [attr.aria-label]="'chat.uploadImage' | t">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-card-image"
                viewBox="0 0 16 16">
                <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                <path
                    d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54L1 12.5v-9a.5.5 0 0 1 .5-.5z" />
            </svg>
        </button>

    </div>
</div>

<!-- AVISO CONFIGURADO POR EL RESTAURANTE -->
<ng-template #modalAviso let-modal>
    <article class="aviso-tarjeta" [class.aviso-sin-imagen]="imagenesAviso.length === 0">
        <button type="button" class="aviso-cerrar-icono" [attr.aria-label]="'notice.close' | t"
            (click)="cerrarAviso(modal)">
            <span aria-hidden="true">&times;</span>
        </button>

        <section class="aviso-media" *ngIf="imagenesAviso.length > 0">
            <ngx-slick-carousel class="aviso-carousel" [config]="avisoSlideConfig"
                [attr.aria-label]="'notice.label' | t"
                (afterChange)="cambioImagenAviso($event)">
                <div ngxSlickItem class="aviso-slide" *ngFor="let imagen of imagenesAviso; let i = index">
                    <div class="aviso-imagen-marco">
                        <img [src]="imagen.UrlImagen" [alt]="'notice.image' | t:{ index: i + 1 }"
                            decoding="async" (error)="ocultarImagenAviso(imagen)">
                    </div>
                </div>
            </ngx-slick-carousel>

        </section>

        <section class="aviso-contenido" *ngIf="mensajeAviso">
            <span class="aviso-etiqueta">{{ 'notice.label' | t }}</span>
            <p class="aviso-mensaje">{{ mensajeAviso }}</p>
        </section>
    </article>
</ng-template>

<!-- MODAL VISTA DE PLATOS -->
<ng-template #modalPlatos let-modal>
    <div class="modal-header dish-modal-header">
        <button type="button" class="btn btn-primary dish-modal-close" (click)="modal.close('')">{{ 'common.close' | t }}</button>
    </div>
    <div class="modal-body dish-modal-body">
        <div id="container-images" class="dish-modal-container">
            <ngx-slick-carousel #dishCarousel id="carrusel-slick" class="carousel dish-modal-carousel" [config]="slideConfig"
                (afterChange)="afterChange($event)">
                <div ngxSlickItem *ngFor="let item of dishes; let index = index" class="slide dish-modal-slide">
                    <article class="box_style_2 dish dish-modal-card">
                        <div class="dish-modal-media" *ngIf="hasDishImage(item)">
                            <img class="dish-modal-image" [src]="getUrlImage(item.Foto)"
                                [alt]="item.Nombre ? ('menu.dishPhoto' | t:{ name: item.Nombre }) : ('accessibility.dishImage' | t)" (error)="onDishImageError(item)">
                        </div>

                        <div class="dish-modal-content">
                            <div class="dish-modal-title-row">
                                <h2 class="inner dish-modal-title">{{item.Nombre}}</h2>
                                <button type="button" class="dish-modal-like" (click)="setLikeModalDish(item)"
                                    [attr.aria-label]="(item.Liked ? 'menu.removeFavorite' : 'menu.addFavorite') | t">
                                    <img *ngIf="!item.Liked" src="./assets/img/heart.png" class="likedImg" alt="">
                                    <img *ngIf="item.Liked" src="./assets/img/heartLiked.png" class="likedImg" alt="">
                                </button>
                            </div>

                            <p class="price dish-modal-price">{{item.Precio | bravumCurrency:currencyState:currencyLocale}}</p>
                            <p class="dish-modal-description">{{item.Descripcion}}</p>

                            <div id="summary_review" class="summary-review" *ngIf="item.Cualidades.length > 0">
                                <div id="general_rating" class="general-rating">{{ 'menu.functionalQualities' | t }}</div>
                                <div class="row rating-summary" id="rating_summary">
                                    <div class="col-md-12">
                                        <table class="table table-dark table-striped dish-modal-table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{{ 'menu.quality' | t }}</th>
                                                    <th scope="col">{{ 'menu.unit' | t }}</th>
                                                    <th scope="col">{{ 'menu.value' | t }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let cualidad of item.Cualidades">
                                                    <td>{{ cualidad.Nombre }}</td>
                                                    <td>{{ cualidad.Desc | replaceNo }}</td>
                                                    <td>{{ cualidad.Valor }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <section class="pairing"
                                *ngIf="selectedDish && selectedDish.IdPlato === item.IdPlato && (recommendationsLoading || productRecommendations.length > 0)"
                                [attr.aria-busy]="recommendationsLoading">
                                <h3 class="pairing-title">{{ 'pairing.title' | t }}</h3>
                                <p class="pairing-loading" *ngIf="recommendationsLoading">{{ 'pairing.loading' | t }}</p>

                                <div class="pairing-grid" *ngIf="!recommendationsLoading">
                                    <article class="pairing-card" *ngFor="let recommendation of productRecommendations">
                                        <div class="pairing-image-wrap" *ngIf="hasRecommendationImage(recommendation)">
                                            <img class="pairing-image" [src]="getUrlImage(recommendation.imagen)"
                                                [alt]="recommendation.nombre ? ('menu.dishPhoto' | t:{ name: recommendation.nombre }) : ('accessibility.dishImage' | t)"
                                                (error)="onRecommendationImageError(recommendation)">
                                        </div>
                                        <div class="pairing-card-content">
                                            <h4>{{ recommendation.nombre }}</h4>
                                            <p class="pairing-price">{{ recommendation.precio | bravumCurrency:currencyState:currencyLocale }}</p>
                                            <p class="pairing-reason">{{ recommendation.reason }}</p>
                                            <button type="button" class="btn btn-outline-primary pairing-action"
                                                (click)="viewRecommendedProduct(recommendation)">
                                                {{ 'pairing.viewDish' | t }}
                                            </button>
                                        </div>
                                    </article>
                                </div>
                            </section>
                        </div>
                    </article>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</ng-template>

<div class="modal-backdrop-custom" *ngIf="showSucursalModal">
    <div class="modal-custom">
        <h3>{{ 'menu.selectBranch' | t }}</h3>

        <p>{{ 'menu.multipleBranches' | t }}</p>

        <div class="sucursal-list">
            <button type="button" class="sucursal-item" *ngFor="let sucursal of sucursales"
                (click)="setSucursal(sucursal)">
                {{ sucursal.Nombre }}
            </button>
        </div>

        <button type="button" class="btn-cancel" (click)="closeSucursalModal()">
            {{ 'common.cancel' | t }}
        </button>
    </div>
</div>
